<template>
  <div>
    <TopHeader2></TopHeader2>
    <section class="logo-header-resp d-md-none my-5">
      <div class="mx-auto">
        <img src="@/assets/images/logos/logoBlack.png" alt="" />
      </div>
    </section>
    <main v-if="homeData" class="main">
      <PagesPath :items="['ویژه همکاران']" :last="'/partners'"></PagesPath>
      <section class="container my-5">
        <div class="partners-grid">
          <div class="my-auto">
            <h6 class="fontsize-large text-color-theme text-right">
              {{ homeData.settings.partner_title1 }}
            </h6>
            <p
              class="fontsize-mini text-color-theme weight-light line-height2-5 text-justify"
            >
              {{ homeData.settings.partner_body1 }}
            </p>
          </div>
          <div class="position-relative">
            <div class="partners-video mx-auto">
              <img
                class="w-100"
                src="@/assets/images/gallery/photos/pic3.png"
                alt=""
              />
            </div>
            <button
              v-if="homeData && homeData.settings.partner_video"
              @click="
                showVideo(
                  'https://api.infinity-align.com/storage/' +
                    homeData.settings.partner_video
                )
              "
              class="partners-video-svg bg-none"
            >
              <svg class="icon">
                <use href="@/assets/svgIcons/svgIcons.svg/#videoPlay"></use>
              </svg>
            </button>
          </div>
        </div>
        <div class="text-center partners-start mt-5">
          <button
            class="border-radius10 py-1 px-4 fontsize-small btn-hover-bulgy"
          >
            شروع همکاری
          </button>
        </div>
      </section>
      <section id="partnerSteps" class="partners-steps pb-5">
        <div class="partners-steps-grid container">
          <div class="">
            <h6 class="fontsize-h3 text-color-theme text-right">
              {{ homeData.settings.partner_title2 }}
            </h6>
            <p
              class="fontsize-mini text-color-theme weight-light line-height2-5 text-justify pl-5"
            >
              {{ homeData.settings.partner_body2 }}
            </p>
          </div>
          <div></div>
        </div>
      </section>

      <div
        @click.self="showVideoBox = false"
        id="showVideoBox"
        v-if="showVideoBox"
      >
        <button id="closeModal" @click="showVideoBox = false">
          <svg
            fill="#000000"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            width="30px"
            height="30px"
          >
            <path
              d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
            />
          </svg>
        </button>
        <video-player
          class="video-player-box"
          ref="videoPlayer"
          :options="playerOptions"
          @ready="playerReadied"
        >
        </video-player>
      </div>
      <StepsJob class="d-md-none mb-5"></StepsJob>
      <!--      <section class="partners-steps container py-5">-->
      <!--        <div class="partners-steps-R">-->
      <!--          <h6 class="fontsize-h3 text-color-theme text-right"> مراحل تعامل با هماران</h6>-->
      <!--          <p class="fontsize-mini text-color-theme weight-light line-height2-5 text-justify">-->

      <!--            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون  بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با  هدف بهبود ابزارهای کاربردی می باشد.  لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون  بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با  هدف بهبود ابزارهای کاربردی می باشد.-->
      <!--          </p>-->
      <!--        </div>-->
      <!--        <div class="partners-steps-L">-->
      <!--          <article class="steps-item d-flex text-right align-items-center mb-2">-->
      <!--            <div class="partners-style-type ml-4"><div></div></div>-->
      <!--            <div class="d-flex align-items-center partners-steps-item rounded-pill p-2">-->
      <!--              <span class="partners-steps-num bg-white rounded-circle fontsize-h3 pt-1 weight-bold text-center">1</span>-->
      <!--              <span class="p-2 fontsize-small text-white d-inline-block"> مرحله اول</span>-->
      <!--            </div>-->
      <!--          </article>-->
      <!--          <article class="steps-item d-flex text-right align-items-center mb-2">-->
      <!--            <div class="partners-style-type ml-4"><div></div></div>-->
      <!--            <div class="partners-steps-item d-flex align-items-center rounded-pill p-2">-->
      <!--              <span class="partners-steps-num bg-white rounded-circle fontsize-h3 pt-1 weight-bold text-center">2</span>-->
      <!--              <span class="p-2 fontsize-small text-white d-inline-block"> مرحله اول</span>-->
      <!--            </div>-->
      <!--          </article>-->
      <!--          <article class="steps-item d-flex text-right align-items-center mb-2">-->
      <!--            <div class="partners-style-type ml-4"><div></div></div>-->
      <!--            <div class="d-flex align-items-center partners-steps-item rounded-pill p-2">-->
      <!--              <span class="partners-steps-num bg-white rounded-circle fontsize-h3 pt-1 weight-bold text-center">3</span>-->
      <!--              <span class="p-2 fontsize-small text-white d-inline-block"> مرحله اول</span>-->
      <!--            </div>-->
      <!--          </article>-->
      <!--          <article class="steps-item d-flex text-right align-items-center mb-2">-->
      <!--            <div class="partners-style-type ml-4"><div></div></div>-->
      <!--            <div class="partners-steps-item d-flex align-items-center rounded-pill p-2">-->
      <!--              <span class="partners-steps-num bg-white rounded-circle fontsize-h3 pt-1 weight-bold text-center">4</span>-->
      <!--              <span class="p-2 fontsize-small text-white d-inline-block"> مرحله اول</span>-->
      <!--            </div>-->
      <!--          </article>-->
      <!--        </div>-->
      <!--      </section>-->

      <section v-if="partners" class="downloads-archive py-lg-5 py-4">
        <div class="container">
          <h6 class="text-white fontsize-heavy text-right mb-lg-5 mb-4">
            آرشیو دانلودها
          </h6>
          <div class="downloads-archive-content">
            <router-link
              v-if="partners.count.blog > 0"
              to="/weblogs?type=partner"
              class="archive-item"
            >
              <div class="archive-item-img">
                <img src="@/assets/images/gallery/photos/pic5.png" alt="" />
              </div>
              <div class="archive-item-content">
                <h6 class="fontsize-large text-color-theme text-center">
                  مقالات
                </h6>
                <p class="fontsize-large text-color-theme text-center mb-0">
                  {{ partners.count.blog }}
                </p>
              </div>
            </router-link>
            <a v-else class="archive-item">
              <div class="archive-item-img">
                <img src="@/assets/images/gallery/photos/pic5.png" alt="" />
              </div>
              <div class="archive-item-content">
                <h6 class="fontsize-large text-color-theme text-center">
                  مقالات
                </h6>
                <p class="fontsize-large text-color-theme text-center mb-0">
                  {{ partners.count.blog }}
                </p>
              </div>
            </a>
            <router-link
              v-if="partners.count.image > 0"
              to="/photos?type=partner"
              class="archive-item"
            >
              <div class="archive-item-img">
                <img src="@/assets/images/gallery/photos/pic2.png" alt="" />
              </div>
              <div class="archive-item-content">
                <h6 class="fontsize-large text-color-theme text-center">
                  تصاویر
                </h6>
                <p class="fontsize-large text-color-theme text-center mb-0">
                  {{ partners.count.image }}
                </p>
              </div>
            </router-link>

            <a v-else class="archive-item">
              <div class="archive-item-img">
                <img src="@/assets/images/gallery/photos/pic2.png" alt="" />
              </div>
              <div class="archive-item-content">
                <h6 class="fontsize-large text-color-theme text-center">
                  تصاویر
                </h6>
                <p class="fontsize-large text-color-theme text-center mb-0">
                  {{ partners.count.image }}
                </p>
              </div>
            </a>
            <router-link
              v-if="partners.count.file > 0"
              to="/files"
              class="archive-item"
            >
              <div class="archive-item-img">
                <img src="@/assets/images/gallery/photos/pic3.png" alt="" />
              </div>
              <div class="archive-item-content">
                <h6 class="fontsize-large text-color-theme text-center">
                  فایل ها
                </h6>
                <p class="fontsize-large text-color-theme text-center mb-0">
                  {{ partners.count.file }}
                </p>
              </div>
            </router-link>

            <a v-else class="archive-item">
              <div class="archive-item-img">
                <img src="@/assets/images/gallery/photos/pic3.png" alt="" />
              </div>
              <div class="archive-item-content">
                <h6 class="fontsize-large text-color-theme text-center">
                  فایل ها
                </h6>
                <p class="fontsize-large text-color-theme text-center mb-0">
                  {{ partners.count.file }}
                </p>
              </div>
            </a>
            <router-link
              v-if="partners.count.video > 0"
              to="/videos?type=partner"
              class="archive-item"
            >
              <div class="archive-item-img">
                <img src="@/assets/images/gallery/photos/pic4.png" alt="" />
              </div>
              <div class="archive-item-content">
                <h6 class="fontsize-large text-color-theme text-center">
                  ویدئوها
                </h6>
                <p class="fontsize-large text-color-theme text-center mb-0">
                  {{ partners.count.video }}
                </p>
              </div>
            </router-link>

            <a v-else class="archive-item">
              <div class="archive-item-img">
                <img src="@/assets/images/gallery/photos/pic4.png" alt="" />
              </div>
              <div class="archive-item-content">
                <h6 class="fontsize-large text-color-theme text-center">
                  ویدئوها
                </h6>
                <p class="fontsize-large text-color-theme text-center mb-0">
                  {{ partners.count.video }}
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section v-if="homeData" id="mainGrid">
        <img :src="'https://api.infinity-align.com/storage/'+homeData.settings.PartnersParticular_image1" alt="" />
        <p>
          {{homeData.settings.PartnersParticular_text1}}
        </p>
        <p>
          {{homeData.settings.PartnersParticular_text2}}
          
        </p>
        <img :src="'https://api.infinity-align.com/storage/'+homeData.settings.PartnersParticular_image1" alt="" />
      </section>
      <section v-if="partners" class="questions">
        <h6 class="fontsize-xheavy text-color-444 text-center mb-4">
          سوالات متداول
        </h6>
        <CommonQuestions :data="partners.faqs"></CommonQuestions>
      </section>
    </main>
  </div>
</template>

<script>
import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";
import CommonQuestions from "../components/CommonQuestions";
import StepsJob from "../components/StepsJob";
export default {
  name: "PartnersParticular",
  components: {
    TopHeader2,
    PagesPath,
    CommonQuestions,
    StepsJob,
  },
  computed: {
    homeData() {
      return this.$root.homeData;
    },
  },
  metaInfo() {
    return {
      title: "همکاران",
    };
  },
  data() {
    return {
      partners: null,
      playerOptions: {
        autoplay: true,
        sources: [
          {
            type: "video/mp4",
            src: null,
          },
        ],
        poster: "/static/images/author.jpg",
      },
      iconSvg: this.iconNum,
      videoResource: null,
      showVideoBox: false,
    };
  },
  methods: {
    setStyle() {
      let goal = document.getElementById("partnerSteps");
      if (goal) {
        let currentWidth = innerWidth;
        let width = 50;
        if (currentWidth > 768 && currentWidth << 1920) {
          width = Math.ceil((1920 - currentWidth) / 23 + 50);
          goal.style.backgroundSize = width + "%";
        }
      }
    },
    showVideo(video) {
      this.playerOptions.sources[0].src = video;
      this.showVideoBox = true;
    },
  },
  mounted() {
    window.addEventListener("resize", this.setStyle);
    this.$axios.get("partner").then((res) => {
      this.partners = res.data.partner;
    });
    const items = document.querySelectorAll(".steps-item");
    let x = 15;
    items.forEach((item) => {
      item.style.marginRight = -x + "px";
      x *= 2.25;
    });

    document.querySelectorAll(".archive-item").forEach((item) => {
      item.style.height = item.offsetWidth + "px";
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setStyle);
  },
};
</script>

<style scoped>
.logo-header-resp > div {
  width: 150px;
}
.logo-header-resp > div img {
  width: 100%;
}
.partners-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 1.5rem;
}
.partners-video {
  width: 80%;
}
.partners-start button {
  background-color: var(--color-theme);
  border: 1px solid var(--color-theme);
  color: white;
  width: 25%;
}
.partners-start button:hover {
  background-color: white;
  color: var(--color-theme);
}
.partners-video img {
  filter: blur(2px);
}
.partners-video-svg {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 25%;
  height: 25%;
}
.partners-video-svg svg {
  width: 100%;
  height: 100%;
}
.partners-steps-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.partners-steps {
  margin-top: 6rem;
  margin-bottom: 6rem;
  background-image: url("../assets/images/backgrounds/backPartnersSteps.png");
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center top;
  height: 60vh;
}
.partners-steps-R {
  border-bottom: 2px dashed #888;
  border-left: 2px dashed #888;
  padding-left: 8rem;
  padding-bottom: 3rem;
  border-radius: 0 0 0 50% / 0 0 0 100%;
}
.partners-style-type {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 6px;
}
.partners-style-type > div {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 5px solid white;
}
.partners-steps-item {
  min-width: 200px;
}
.steps-item:nth-child(2n + 1) .partners-style-type,
.steps-item:nth-child(2n + 1) .partners-steps-item {
  background-color: var(--color-theme);
}
.steps-item:nth-child(2n) .partners-style-type,
.steps-item:nth-child(2n) .partners-steps-item {
  background-color: #90b067;
}
.steps-item:nth-child(2n + 1) .partners-steps-num {
  color: var(--color-theme);
}
.steps-item:nth-child(2n) .partners-steps-num {
  color: #90b067;
}
.partners-steps-num {
  display: inline-block;
  width: 40px;
  height: 40px;
}

.downloads-archive {
  background-image: url("../assets/images/backgrounds/backArchive.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-bottom: 6rem;
}
.downloads-archive-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 2rem;
}
.archive-item {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
}
.archive-item-img {
  height: 100%;
  width: 100%;
  background-color: white;
}
.archive-item-img img {
  width: 100%;
  height: 100%;
  filter: opacity(30%);
}
.archive-item:hover {
  transform: translateY(-2px);
}
.archive-item:hover .archive-item-img img {
  filter: opacity(50%);
}
.archive-item-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  padding: 10px;
}
.questions {
  margin-bottom: 6rem;
}

@media screen and (max-width: 991px) {
  .downloads-archive-content {
    grid-gap: 2rem;
  }
}
@media screen and (max-width: 767px) {
  .partners-steps {
    display: none;
  }
  .partners-grid {
    grid-template-columns: 1fr;
  }
  .partners-start button {
    width: 45%;
  }
  .downloads-archive-content {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 2rem;
  }
}
@media screen and (max-width: 500px) {
  .downloads-archive-content {
    grid-gap: 1rem;
  }
}
@media screen and (max-width: 320px) {
  .downloads-archive-content {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
  }
}

#showVideoBox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 100000000;
  align-items: center;
  background-color: #000000b3;
}
button#closeModal {
  position: fixed;
  right: 1%;
  top: 1%;
  border-radius: 10px;
  padding: 10px;
  background: silver;
  z-index: 100000;
}
section#mainGrid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 80%;
    margin: 24px auto;
    align-items: center;
    gap: 16px;
}
section#mainGrid img {
  width: 100%;
}
section#mainGrid p {
  direction: rtl;
  text-align: justify;
}
@media (max-width:768px){
  section#mainGrid {
    grid-template-columns: 1fr;
  }
}
</style>
